import React from 'react'
import { useStyles } from './Sidebar.style'
import { localtext } from './Sidebar.static'

export interface SidebarProps {
  children?: React.ReactNode
  className?: string
}

export const Sidebar: React.FC<SidebarProps> = ({ children, className }) => {
  const { classes, cx } = useStyles()

  return (
    <nav className={cx(classes.drawer, className)} aria-label={localtext.AriaLabel}>
      <div className={classes.content}>{children}</div>
    </nav>
  )
}
